import Helper from "./Helper";

class Cv {
  constructor() {
    this.cvsToggler = document.querySelectorAll('.ns-cv__toggle');
    this.cvsTogglerArray = Array.prototype.slice.call(this.cvsToggler);

    this.bindEvents();
  }

  bindEvents() {
    this.cvsTogglerArray.forEach((toggle) => {
      toggle.addEventListener('click', (e) => {
        Helper.toggleClass(toggle.parentNode, 'open');
        Helper.toggleClass(toggle, 'active');
      });
    });
  }
}

export default Cv;
